import { JSX } from '@ncr-design-system/keyboard'
import { createReactComponent } from './createComponent'

export const Keyboard = /*@__PURE__*/ createReactComponent<JSX.NcrKeyboard, HTMLNcrKeyboardElement>('ncr-keyboard')
export const KeyboardButton = /*@__PURE__*/ createReactComponent<JSX.NcrKeyboardButton, HTMLNcrKeyboardButtonElement>(
  'ncr-keyboard-button'
)
export const KeyboardLayout = /*@__PURE__*/ createReactComponent<JSX.NcrKeyboardLayout, HTMLNcrKeyboardLayoutElement>(
  'ncr-keyboard-layout'
)
